/**
 * @generated SignedSource<<e9e2d55dc6842494c599a4ebc3a4daa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionEntitySubmissionStatusEntityFragment$data = {
  readonly id: string;
  readonly username: string;
  readonly " $fragmentType": "CompetitionEntitySubmissionStatusEntityFragment";
};
export type CompetitionEntitySubmissionStatusEntityFragment$key = {
  readonly " $data"?: CompetitionEntitySubmissionStatusEntityFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionEntitySubmissionStatusEntityFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionEntitySubmissionStatusEntityFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "ba32ce109e248b1ea3226cd724af5c64";

export default node;
